<form form="ngForm">
    <select [(ngModel)]="tipo" id="tipo" name="relacao" class="form-control" (change)="onChange()" appShowErrorMessages [required]="required">
    <option value="1">Residencial</option>
    <option *ngIf="showComercial" value="2">Comercial</option>
    <option value="7">Outro</option>
 </select>
</form>